/**
 * DeepLinkHybrid const symbols.
 * @constant
 * @type {Object}
 */
const DEEP_LINK_HYBRID = {
    TYPE: "deeplinkfeature"
};


export {DEEP_LINK_HYBRID};